import { type ReactElement, type RefObject, ReactNode } from 'react';
import { CallControlBarContainer } from './callControlBarContainer';

export const CONTROL_BAR_HEIGHT = 48;

/**
 * Bottom flip padding for i.e. the NameTag menus so they clear the CallBar.
 */
export const CALL_BAR_BOTTOM_FLIP_PADDING_PX = CONTROL_BAR_HEIGHT + 44;

export type CallControlBarProps = {
  controlBarRef?: RefObject<HTMLDivElement | null>;
  children?: ReactNode;
};

export const CallControlBar = ({
  controlBarRef,
  children,
}: CallControlBarProps): ReactElement => {
  return (
    <CallControlBarContainer controlBarRef={controlBarRef}>
      {children}
    </CallControlBarContainer>
  );
};
